import moment from 'moment-jalaali';

export default function DateCheck(date) {
    try {
        if(date) {
            return true;
            // const unixNow = moment().unix();
            // const unitDate = moment(date, 'jYYYY/jMM/jDD').unix();
            // let def = unitDate - unixNow;

            // if(def > 0) {
            //     return true;
            // } else {
            //     def *= -1;
            //     if((def/60/60/24) < 1) return true;
            //     else return false; 
            // }
        } else {
            return false;
        }
    } catch {
        return false;
    }
}